export default class NumberFormatter {

    static isNumber(val) {
        return val && val.toString().match(/^[\d,.]+$/)
    }

    static format(nr) {
        return this.isNumber(nr)
            ? nr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            : nr;
    }

    static formatCompactNumber(number) {
        if (number < 1000) {
            return number;
        } else if (number >= 1000 && number < 1_000_000) {
            return (number / 1000).toFixed(1) + "K";
        } else if (number >= 1_000_000 && number < 1_000_000_000) {
            return (number / 1_000_000).toFixed(1) + "M";
        } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
            return (number / 1_000_000_000).toFixed(1) + "B";
        } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
            return (number / 1_000_000_000_000).toFixed(1) + "T";
        }
    }

}